import { TextInput } from '@core/components/Inputs';
import { SelectInput } from '@core/components/Select';
import { TableActionButton, TableActionContainer } from '@core/components/TableAction';
import { Grid, Tooltip, makeStyles } from '@material-ui/core';
import { ClearAll } from '@material-ui/icons';
import InputMonetario from 'app/components/Input/InputMonetario';
import SelectCategoria from 'app/components/Select/SelectCategoria';
import SelectFornecedor from 'app/components/Select/SelectFornecedor';
import { FormikProvider } from 'formik';
import React, { useContext, useEffect } from 'react';
import { FaInfoCircle, FaPlus, FaSearch } from 'react-icons/fa';
import { ConciliacaoContext } from '../ConciliacaoContext';

const useStyles = makeStyles(() => ({
  firstRadioOption: {
    paddingLeft: '1%',
  },
  lastRadioOption: {
    paddingRight: '1%',
  },
  customIcons: {
    fontSize: '16px',
  },
}));

export const FormLancamentoDespesa = ({
  formik,
  exibirTitulo,
  exibirAcoes,
  handlerPesquisar,
  handlerLimparInformacoes,
  temPermissaoParaVisualizar,
  temPermissaoParaCadastrar,
  handlerLancarContaPagar,
}) => {
  const classes = useStyles();

  const _errors = {
    fornecedorDespesa:
      (formik?.submitCount > 0 || formik?.touched?.fornecedorDespesa) && formik?.errors?.fornecedorDespesa,
    categoriaDespesa:
      (formik?.submitCount > 0 || formik?.touched?.categoriaDespesa) && formik?.errors?.categoriaDespesa,
    valorDespesa: (formik?.submitCount > 0 || formik?.touched?.valorDespesa) && formik?.errors?.valorDespesa,
    formaPagamentoDespesa:
      (formik?.submitCount > 0 || formik?.touched?.formaPagamentoDespesa) && formik?.errors?.formaPagamentoDespesa,
    numeroChequeDespesa:
      (formik?.submitCount > 0 || formik?.touched?.numeroChequeDespesa) && formik?.errors?.numeroChequeDespesa,
  };

  return (
    <>
      {exibirTitulo && (
        <div style={{ margin: '15px 0px' }}>
          <b>DESPESA</b>
        </div>
      )}
      <Grid container className="mt-8">
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <SelectFornecedor
            id="fornecedorDespesa"
            idObject="fornecedorDespesa"
            label="Fornecedor"
            fornecedor={formik.values?.fornecedorDespesa}
            handleChange={formik.handleChange}
            onBlur={formik.handleBlur}
            touched={!!_errors.fornecedorDespesa}
            error={_errors.fornecedorDespesa}
            required
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} className="mt-8">
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <SelectCategoria
            id="categoriaDespesa"
            label="Categoria"
            value={formik.values?.categoriaDespesa}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            maxLength={100}
            natureza="DESPESA"
            required
            touched={!!_errors.categoriaDespesa}
            error={_errors.categoriaDespesa}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <InputMonetario
            required
            id="valorDespesa"
            label="Valor (R$)"
            fullWidth
            handleChange={formik.handleChange}
            value={formik.values?.valorDespesa}
            onBlur={formik.handleBlur}
            maximumValue={'999999999.99'}
            touched={!!_errors.valorDespesa}
            error={_errors.valorDespesa}
            helperText={_errors.valorDespesa} // O texto de validação do Yup só aparece com o helperText
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} className="mt-8">
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <SelectInput
            id="formaPagamentoDespesa"
            label="Forma de pagamento"
            required
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values?.formaPagamentoDespesa}
            error={_errors?.formaPagamentoDespesa}
            touched={!!_errors?.formaPagamentoDespesa}
            options={[
              { id: 'CARTAO_CREDITO', title: 'Cartão de crédito' },
              { id: 'CARTAO_DEBITO', title: 'Cartão de débito' },
              { id: 'CHEQUE', title: 'Cheque' },
              { id: 'DEBITO_AUTOMATICO', title: 'Débito automático' },
              { id: 'DEBITO_CONTA', title: 'Débito em conta' },
              { id: 'DOC', title: 'DOC' },
              { id: 'TED', title: 'TED' },
              { id: 'TRANSFERENCIA_BANCARIA', title: 'Transferência bancária' },
              { id: 'DINHEIRO', title: 'Dinheiro' },
              { id: 'BOLETO', title: 'Boleto' },
              { id: 'PIX', title: 'Pix' },
              { id: 'OUTRAS', title: 'Outras' },
            ]}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          {formik.values?.formaPagamentoDespesa === 'CHEQUE' && (
            <TextInput
              id="numeroChequeDespesa"
              label="Número do cheque"
              value={formik.values?.numeroChequeDespesa}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              maxLength={20}
              pattern={/^\d*$/}
              required
              error={_errors?.numeroChequeDespesa}
              touched={!!_errors?.numeroChequeDespesa}
            />
          )}
        </Grid>
      </Grid>
      {exibirAcoes && (
        <Grid item xs={12} style={{ margin: '10px 0px', textAlign: 'end' }}>
          <TableActionContainer>
            {temPermissaoParaVisualizar && (
              <TableActionButton
                title="Pesquisar conta"
                icon={<FaSearch size={16} />}
                onClick={() => handlerPesquisar()}
              />
            )}
            {temPermissaoParaCadastrar && (
              <TableActionButton
                title="Lançar conta"
                icon={<FaPlus size={16} />}
                onClick={() => handlerLancarContaPagar()}
              />
            )}
            <TableActionButton
              title="Limpar informações"
              icon={<ClearAll size={12} className={classes.customIcons} />}
              onClick={() => handlerLimparInformacoes()}
            />
          </TableActionContainer>
        </Grid>
      )}
    </>
  );
};

const FormularioLancamentoDespesa = ({ formik, extrato }) => {
  const [conciliacoes, setConciliacoes] = useContext(ConciliacaoContext).conciliacoes;

  const tooltip =
    'Esta é uma sugestão do novo lançamento. Caso concorde, preencha os ' +
    'demais campos e clique em “Conciliar” para que uma nova conta a pagar ' +
    'baixada seja criada. Caso não concorde, selecione outra ação.';

  const atualizarExtrato = (extrato) => {
    conciliacoes
      .filter((c) => c.id === extrato.id)
      .forEach((c) => {
        if (!c.contaPagarList || (c.contaPagarList && c.contaPagarList.length === 1)) {
          if (
            formik?.values?.fornecedorDespesa &&
            formik?.values?.categoriaDespesa &&
            formik?.values?.valorDespesa &&
            formik?.values?.formaPagamentoDespesa
          ) {
            c.contaPagarList = [
              {
                fornecedor: formik?.values?.fornecedorDespesa,
                categorias: [formik?.values?.categoriaDespesa],
                valor: formik?.values?.valorDespesa,
                formaPagamento: formik?.values?.formaPagamentoDespesa,
                numeroCheque: formik.values?.numeroChequeDespesa,
                formulario: true,
              },
            ];
          }
        }
      });

    setConciliacoes(conciliacoes);
  };

  const formikValues = formik?.values;
  useEffect(() => {
    atualizarExtrato(extrato);
    extrato.valorFormulario = formikValues?.valorDespesa;
    // A função é recriada a cada render; incluí-la reexecutaria a busca em loop.
    // O efeito depende apenas do gatilho listado.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formikValues]);

  return (
    <>
      <FormikProvider value={formik}>
        <Grid style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
          <Tooltip title={tooltip} placement="right-end">
            <button type="button" onClick={() => {}}>
              <FaInfoCircle size={18} style={{ color: '#f2994a' }} />
            </button>
          </Tooltip>
        </Grid>
        <FormLancamentoDespesa formik={formik} />
      </FormikProvider>
    </>
  );
};

export default FormularioLancamentoDespesa;
